import styled from "styled-components";
import media from "styled-media-query";

export const Card = styled.div`
  background-color: #144BC8;
  border: 3px solid #FFFFFF;
  border-radius: 20px;
  color: #fff;
  position: relative;
  height: 379.47px;

  ${media.lessThan('1366px')`
    height: 280px;
    border: 2px solid #FFFFFF;
  `}
  
  ${media.lessThan('1024px')`
    height: 200px;
  `}

  .title-card {
    position: absolute;
    top: -25px;
    transform: translatex(-50%);
    left: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 245px;
    height: 61.34px;
    background-color: #000;
    border: 2px solid #1A84D6;

    h3 {
      font-weight: 900;
      font-size: 25px;
      line-height: 30px;
      text-transform: uppercase;
      color: #fff;
    }
    

    ${media.lessThan('1366px')`
      max-width: 172px;
      height: 52px;

      h3 {
        font-size: 18px;
        line-height: 20px;
      }
    `}

    ${media.lessThan('1024px')`
      max-width: 245px;
    `}
  }

  .description-card {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0 23px;

    ${media.lessThan('1024px')`
      width: 100%;
      max-width: 303px;
      padding: 16px 23px 0;
    `}

    p {
      font-weight: 600;
      font-size: 22px;
      line-height: 27px;
      text-align: center;
      color: #FFFFFF;

      ${media.lessThan('1366px')`
        font-size: 16px;
        line-height: 22px;
      `}

      ${media.lessThan('1024px')`
        font-size: 18px;
        line-height: 22px;
      `}
    }
  }
`